<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link
                    :to="{
                        name: 'other',
                    }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">
                {{
                    selectCategory.length > 0
                        ? selectCategory[0].product_name
                        : 'Loading...'
                }}
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <div class="section mt-1" v-if="product.length > 10">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Cari Produk"
                            v-model="keywords"
                        />
                        <i class="clear-input">
                            <ion-icon
                                name="close-circle"
                                @click="clearKeywords()"
                            ></ion-icon>
                        </i>
                    </div>
                </div>
            </div>

            <!-- List Product -->
            <div class="section mt-2">
                <!-- Style Product "LIST" -->
                <div class="transactions" v-if="product.length > 0">
                    <!-- item -->
                    <a
                        href="javascript:;"
                        v-for="itemProduct in filterProduct(product)"
                        :key="itemProduct.id"
                        class="item"
                        style="padding: 10px"
                        @click="selectProduct(itemProduct)"
                    >
                        <div class="detail">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    itemProduct.icon
                                        ? VUE_ENV.VUE_APP_ASSET_URL +
                                          '/img/icon/operator/' +
                                          itemProduct.icon
                                        : require('@/assets/Loader-2.png')
                                "
                                alt="image"
                                class="image-block imaged"
                                style="width: 30px"
                            />
                            <div style="color: #17273e">
                                <b>{{ itemProduct.product_name }}</b>
                                <footer>
                                    <small>{{ itemProduct.description }}</small>
                                </footer>
                            </div>
                        </div>

                        <div class="right">
                            <div class="icon">
                                <ion-icon
                                    name="chevron-forward-outline"
                                ></ion-icon>
                            </div>
                        </div>
                    </a>
                    <!-- * item -->
                </div>

                <div class="text-center mt-3" v-else-if="!loading.content">
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="empty"
                        class="w-75"
                    /><br />
                    <h2 class="mb-0">Belum Ada Data</h2>
                    <p>Tidak ada data yang dapat ditampilkan</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $axios from './../../../api.js';
    import { mapState } from 'vuex';
    export default {
        props: ['toast_reference'],
        data() {
            return {
                loading: {
                    content: true,
                },
                product: [],
                keywords: '',
            };
        },
        created() {
            this.getProduct();
            // window.fbq('track', 'ViewContent');
        },
        computed: {
            ...mapState([
                'customer',
                'toast',
                'VUE_ENV',
                'device',
                'categoryPascabayar',
            ]),
            selectCategory() {
                return this.categoryPascabayar.filter(item => {
                    return item.id == this.$route.params.id;
                });
            },
        },
        methods: {
            filterProduct: function (product) {
                var app = this;
                return product.filter(function (item) {
                    let regex = new RegExp('(' + app.keywords + ')', 'i');
                    return item.product_name.match(regex);
                });
            },
            selectProduct(data) {
                this.$router.push({
                    name: 'pascabayar-order',
                    params: {
                        id: data.id, // product id
                        product_selected: data, // product detail
                    },
                });
            },
            getProduct() {
                this.product = [];
                $axios
                    .post('/pascabayar/product', {
                        category_id: this.$route.params.id,
                    })
                    .then(response => {
                        if (response.data.data.length > 0) {
                            this.product = response.data.data;
                            this.loading.content = false;
                        } else {
                            this.product = [];
                            this.loading.content = false;
                        }
                    })
                    .catch(e => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: e.response.data.message,
                            tipe: 'default',
                        });
                        this.loading.content = false;
                    });
            },
            clearKeywords() {
                this.keywords = '';
            },
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.showStatus();
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
